import type { InterventionTemplateJsonEditorProps } from "./intervention-template-json-editor.type";

import { JsonEditor } from "@/ui/json-editor";

import { useInterventionTemplateJsonEditor } from "./intervention-template-json-editor.hook";

export const InterventionTemplateJsonEditor = ({
  template,
}: InterventionTemplateJsonEditorProps) => {
  const { templates, isEditable, onSchemaChange } =
    useInterventionTemplateJsonEditor({ template });

  return (
    <JsonEditor
      schema={[...templates]}
      onSchemaChange={onSchemaChange}
      isEditable={isEditable}
      fullHeight
    />
  );
};
